import {
  DatabaseService,
  TemporaryDeal,
  TemporaryDealData,
  TemporaryDealRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getTemporaryDealRepository(
  databaseService: DatabaseService,
): TemporaryDealRepository {
  return getGenericRepository<TemporaryDeal, TemporaryDealData>(
    () => DatabaseCollection.TEMPORARY_DEALS,
    databaseService,
  );
}
